var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:quarkbold;src:url(" + escape(require("./quark-bold.eot")) + ");src:url(" + escape(require("./quark-bold.eot")) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(require("./quark-bold.woff")) + ") format(\"woff\"),url(" + escape(require("./quark-bold.ttf")) + ") format(\"truetype\"),url(" + escape(require("./quark-bold.svg")) + "#quarkbold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:quarklight;src:url(" + escape(require("./quark-light.eot")) + ");src:url(" + escape(require("./quark-light.eot")) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(require("./quark-light.woff")) + ") format(\"woff\"),url(" + escape(require("./quark-light.ttf")) + ") format(\"truetype\"),url(" + escape(require("./quark-light.svg")) + "#quarklight) format(\"svg\");font-weight:400;font-style:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/assets/fonts/Quark/quark.css
// module id = 1D4Y
// module chunks = 0